import { useEffect, useRef } from 'react';
import { useAuthContext } from '../../hooks/AuthContext';
import { useControllerFlowStepsContext } from '../../hooks/ControllerFlowStepsContext';
import LoadingFullScreen, {
  LoadingFullScreenHandles
} from '../LoadingFullScreen/LoadingFullScreen';
import BackToAppFullScreen, {
  BackToAppFullScreenHandles
} from '../BackToAppFullScreen/BackToAppFullScreen';

import './Wrapper.scss';

interface WrapperProps {
  className?: string;
  children: React.ReactNode;
}
export default function Wrapper(props: WrapperProps) {
  const { openGoBackToApp } = useAuthContext();
  const { loadingFullScreen } = useControllerFlowStepsContext();
  const refLoadingFullScreen = useRef<LoadingFullScreenHandles>(null);
  const refGoBackToAppFullScreen = useRef<BackToAppFullScreenHandles>(null);

  useEffect(() => {
    if (loadingFullScreen) {
      refLoadingFullScreen?.current?.openLoadingFullScreen();
    } else {
      refLoadingFullScreen?.current?.closeLoadingFullScreen();
    }
  }, [loadingFullScreen]);

  useEffect(() => {
    if (openGoBackToApp) {
      refGoBackToAppFullScreen?.current?.openBackToAppFullScreen();
    } else {
      refGoBackToAppFullScreen?.current?.closeBackToAppFullScreen();
    }
  }, [openGoBackToApp]);

  return (
    <>
      <div className={`wrapper flex ${props.className || ''}`}>
        {props.children}
      </div>
      <LoadingFullScreen ref={refLoadingFullScreen} />
      <BackToAppFullScreen ref={refGoBackToAppFullScreen} />
    </>
  );
}
